import React from "react"
import { Route } from "react-router-dom"
import { DealDetailModal } from "@components/content-feed/teaser/Deal"

const DealRoute = ({ items }) => (
  <Route
    path="/deal/:id"
    component={({
      match: {
        params: { id },
      },
    }) => {
      const item = items.find(i => i.id == id || i.teaser_id == id)
      if (!item) {
        console.error("item not found", id)
        return null
      }
      return (
        <DealDetailModal onHide={() => void (location.hash = "#/")} {...item} />
      )
    }}
  />
)

export default DealRoute
